import { useEffect } from "react";
import { create } from "zustand";
import { leitenSingleton } from "../../leiten/controllers/leitenFeature";
import { leitenGroupRequest } from "../../leiten/controllers/leitenGroupRequest";
import { ApiGetUsesRemaining } from "../../requests/getUsesRemaining";
export const usesRemainingSingleton = leitenSingleton(({ mount }) => {
    const useStore = create(() => ({
        uses: {},
    }));
    const chanel = new BroadcastChannel("uses_remaining");
    chanel.addEventListener("message", (event) => {
        useStore.setState((state) => ({
            uses: { ...state.uses, [event.data.key]: event.data.result },
        }));
    });
    mount(() => () => chanel.close());
    const useGetUsesRequest = leitenGroupRequest(useStore, "uses", async ({ key }) => {
        return ApiGetUsesRemaining.get(key);
    }, {
        fulfilled: ({ payload, result }) => {
            chanel.postMessage({ key: payload.key, result });
        },
    });
    const getData = (key) => useGetUsesRequest.action([{ key, params: undefined }]);
    const mountedRef = {};
    const useMount = (key) => {
        useEffect(() => {
            if (!mountedRef[key]) {
                getData(key);
            }
            mountedRef[key] = (mountedRef[key] || 0) + 1;
            return () => {
                mountedRef[key] = (mountedRef[key] || 0) - 1;
            };
        }, []);
    };
    const useUses = (key) => {
        return useStore((state) => state.uses[key]);
    };
    return { useStore, getData, useUses, useMount, useGetUsesRequest };
});
